// employee/reducers.ts
const initialState = {
    getOutstandingData: [],
    getOutstandingCount: null,
    getOutstandingMetaMessage: null,
    getOutstandingSuccess: false,
    getOutstandingFailure: false,
   
};

export default function OutstandingReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_OUTSTANDING_SUCCESS': {
            return {
                ...state,
                getOutstandingSuccess: true,
                getOutstandingData: action.payload?.data?.data?.data,
                getOutstandingCount:action.payload?.data?.data?.meta?.total,
                getOutstandingFailure: false,
            };
        }
        case 'GET_OUTSTANDING_FAILURE': {
            return {
                ...state,
                getOutstandingFailure: true,
                getOutstandingMetaMessage: action.payload?.data?.data?.meta?.message,
                getOutstandingSuccess: false,
            };
        }
        case 'RESET_GET_OUTSTANDING': {
            return {
                ...state,
                getOutstandingSuccess: false,
                getOutstandingFailure: false,
                getOutstandingData: [],
                getOutstandingMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
